// extracted by mini-css-extract-plugin
export var actionIcon = "_jj-0";